import React from "react";
import {
	SectionHeading,
	SettingsFormContainer,
	SaveSettingButton,
	FieldsContainer,
} from "../../styles/common.styles";
import SettingsSnackbar from "../../components/SettingsSnackbar";
import SettingsSwitchField from "../../components/SettingsSwitchField";

import { AlertColor } from "@mui/material/Alert";
import Typography from "@mui/material/Typography";

interface Props {
	handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
	loading: boolean;
	notice: { type: AlertColor; message: string };
	showNotice: boolean;
	setShowNotice: React.Dispatch<React.SetStateAction<boolean>>;
	settings: Record<string, string | boolean | string[]>;
	setSettings: React.Dispatch<
		React.SetStateAction<Record<string, string | boolean | string[]>>
	>;
	setSettingsPromise: (
		value: React.SetStateAction<Record<string, string | boolean | string[]>>,
	) => Promise<Record<string, string | boolean | string[]>>;
	handleUpdateSettings: (
		settings: Record<string, string | boolean | string[]>,
	) => void;
}

const StoreSettings = ({
	handleSubmit,
	loading,
	notice,
	showNotice,
	setShowNotice,
	settings,
	setSettings,
	setSettingsPromise,
	handleUpdateSettings,
}: Props) => {
	return (
		<SettingsFormContainer>
			<form onSubmit={(e) => handleSubmit(e)}>
				<SettingsSnackbar
					notice={notice}
					showNotice={showNotice}
					setShowNotice={setShowNotice}
				/>

				<FieldsContainer>
					<SectionHeading variant='h6'>Store settings</SectionHeading>

					<SettingsSwitchField
						settings={settings}
						setSettingsPromise={setSettingsPromise}
						label='Set SMS notification default to subscribe'
						slug='checkout-sms-subscription-default'
						helper={
							<Typography variant='subtitle2' sx={{ p: 2 }}>
								Default SMS subscription on checkout page.{" "}
								<a
									href='https://www.messageflow.co/'
									target='_blank'
									rel='noreferrer'>
									Read More
								</a>
							</Typography>
						}
						handleUpdateSettings={handleUpdateSettings}
					/>
				</FieldsContainer>

				<SaveSettingButton
					loading={loading}
					size='large'
					variant='contained'
					type='submit'>
					Save settings
				</SaveSettingButton>
			</form>
		</SettingsFormContainer>
	);
};

export default StoreSettings;
